import React from 'react'
import { CheckIcon } from 'components/Icons';
import { useTranslation } from 'react-i18next';

const PaymentModalContent = ({user}) => {
    const { t } = useTranslation();
    return (
        <div className="payment-content-modals d-flex flex-column justify-content-start" >
            <p className="payment-modal-content font-weight-bold font-size-14" style={{ color: '#E7EAF3' }}> {t('Subscribe to get these benefits')}</p>
            <div className="payment-modal-content-benefits d-flex">
                <div>
                    <div className="benefit-checks d-flex">
                        <CheckIcon height="24px" width="24px" fill="#27C9FD" />
                        <p className="font-size-12 d-flex align-items-center" style={{ color: '#E7EAF3' }}>{t(`Full access to `)}  
                         { user.name}{t("'s channel content")}</p>
                    </div>

                    <div className="benefit-checks d-flex">
                        <CheckIcon height="24px" width="24px" fill="#27C9FD" />
                        <p className="font-size-12 d-flex align-items-center" style={{ color: '#E7EAF3' }}>{t(`Full acces to all interactions in `)} {user.name} {t("'s channel")}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PaymentModalContent;